export const container = `flex flex-col gap-3 p-3 min-w-48 max-w-80`;
export const content = `text-xs`;
